import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { GrLocation } from "react-icons/gr";
import { MdMailOutline, MdOutlinePhone } from "react-icons/md";
import { IoIosSend } from "react-icons/io";

const Contact = ({ MarginTop }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");
  const [responseType, setResponseType] = useState("");

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      setResponseMsg("");

      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("email", data.email);
      formData.append("message", data.message);

      const response = await fetch(
        "https://bwefinserv.com/services/contact.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok && result.success) {
        setResponseType("success");
        setResponseMsg(result.message || "Message sent successfully.");
        reset();
      } else {
        setResponseType("error");
        setResponseMsg(result.error || "Failed to send message.");
      }
    } catch (error) {
      console.error(error);
      setResponseType("error");
      setResponseMsg("Something went wrong. Please try again.");
    } finally {
      setLoading(false);

      setTimeout(() => {
        setResponseMsg("");
      }, 5000);
    }
  };

  return (
    <section id="contact" style={{ scrollMarginTop: MarginTop }}>
      <div className="home-section our_services_sec">
        <div className="title-section">
          <h1 className="head-title">Contact & Support</h1>
          <span className="title-under-line"></span>
          <p className="title-disc">Have a question or need assistance? Our team is here to provide
            expert support, answer your queries, and help you make the most of
            our lending solutions.</p>
        </div>
        <div className="contact-full-cont">
          <div className="contact-left-side-contents">
            <div className="contact-form-card">
              <h2>Get in Touch</h2>
              <p>We're here to help! Reach out to us for any inquiries or support. </p>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="contact-input">
                  <div className="cont-left-side-input">
                    <div className="dash-fm-group">
                      <label>Name <span className="important_star">*</span></label>
                      <input
                        {...register("name", {
                          required: "Name is required",
                        })}
                        placeholder="Enter Name"
                      />
                      {errors.name && (<p className="error-message">{errors.name.message}</p>)}
                    </div>

                    <div className="dash-fm-group">
                      <label>Email <span className="important_star">*</span></label>
                      <input
                        type="email"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value:
                              /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Enter a valid email address",
                          },
                        })}
                        placeholder="Enter Email"
                      />
                      {errors.email && (<p className="error-message">{errors.email.message}</p>)}
                    </div>
                  </div>

                  <div className="cont-right-side-input">
                    {/* Message */}
                    <div className="dash-fm-group">
                      <label>Write a Message{" "} <span className="important_star">*</span></label>

                      <textarea
                        // rows={8}
                        {...register("message", {
                          required: "Message is required",
                        })}
                        placeholder="Write a Message"
                      />

                      {errors.message && (
                        <p className="error-message">
                          {errors.message.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                {responseMsg && (
                  <div className={`contact-response ${responseType}`}
                    style={{
                      marginBottom: "15px",
                      padding: "10px 15px",
                      borderRadius: "6px",
                      color:
                        responseType === "success"
                          ? "#155724"
                          : "#721c24",
                      background:
                        responseType === "success"
                          ? "#d4edda"
                          : "#f8d7da",
                      border:
                        responseType === "success"
                          ? "1px solid #c3e6cb"
                          : "1px solid #f5c6cb",
                    }}
                  >{responseMsg} </div>
                )}

                {/* Submit Button */}
                <button
                  type="submit"
                  className="contact-submit-btn"
                  disabled={loading}
                >
                  <IoIosSend size={16} />

                  {loading ? " Sending..." : " Submit"}
                </button>
              </form>
            </div>

            {/* Google Map */}
            <div className="contact-map-card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.2361311045374!2d76.97469168456355!3d11.0209021611494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba859af9302ac01%3A0x9b990afe6c9ea013!2sAstral%20Consulting%20Ltd!5e0!3m2!1sen!2sin!4v1752660315276!5m2!1sen!2sin"
                loading="lazy"
                allowFullScreen=""
                referrerPolicy="no-referrer-when-downgrade"
                title="BWE Office Location Map"
              ></iframe>
            </div>
          </div>

          {/* Right Side */}
          <div className="contact-right-side-contents">
            <div className="contact-info-card">
              <h3>Contact Information</h3>

              <div className="info-box">
                <GrLocation />
                <div>
                  <h6>Our Address</h6>
                  <p>
                    14 A, 4th Floor, Ramakrishna Nagar,
                    <br />
                    New Siddhapudur, Coimbatore,
                    <br />
                    Tamil Nadu - 641044.
                  </p>
                </div>
              </div>

              <div className="info-box">
                <MdMailOutline />
                <div>
                  <h6>Email Address</h6>
                  <p><a href='mailto:contact@bwefinserv.com' target='_blank' rel="noreferrer">contact@bwefinserv.com</a></p>
                </div>
              </div>

              <div className="info-box">
                <MdOutlinePhone />
                <div>
                  <h6>Phone Number</h6>
                  <p><a href='tel:6383830073' target='_blank' rel="noreferrer">63838 30073</a></p>
                </div>
              </div>
            </div>

            <div className="support-card">
              <h3>Why Choose BWE Finserv?</h3>

              <p>
                BWE Finserv empowers financial institutions with practical,
                secure, and configurable technology that simplifies the entire
                lending lifecycle.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;